import { Collapse, Input, Button, Modal, Spin } from "antd";
import { useTranslation } from "react-i18next";
import { ConfigureAddon } from "@/components/instance/control/ConfigureAddon";
import { useEffect, useState } from "react";
import { showAddonDetail } from "@/apis/addons";
import { useHandleNotification, useUpdate } from "@refinedev/core";

export const EditAddon = ({ id, addonId, addonName, onBack }) => {
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);
  const [addon, setAddon] = useState({});
  const [dirty, setDirty] = useState(false);
  const handleNotification = useHandleNotification();

  const { mutate, isLoading: isUpdating } = useUpdate({
    mutationOptions: {
      onSuccess: (data) => {
        handleNotification({
          message: t(`addon.actionResult.update.success`, {addonName}),
          description: 'Success',
          type: "success"
        });
        onBack && onBack("");
      },
      onError: (error) => {
        handleNotification({
          message: t(`addon.actionResult.update.failed`, {addonName}),
          description: 'Success',
          type: "success"
        });
        console.error('Update failed', error);
      }
    }
  });
  useEffect(() => {
    const getAddon = async () => {
      try {
        setIsLoading(true);
        const result = await showAddonDetail(id, addonId);
        if("OK" == result.status && result.value) {
          setAddon(result.value.addon);
        }
      } catch (error) {
        console.error("get built-in users failed:", error);
      } finally {
        setIsLoading(false);
      }
    };
    getAddon();
  }, [id, addonId]);


  const updateAddon = (newAddon, modified) => {
    if(modified) {
      setAddon({...newAddon});
      setDirty(true);
    }
  };

  const handleSave = () => {
    Modal.confirm({
      title: t("addon.updateConfirm", "Update Add-on"),
      content: t("addon.updateConfirmContent", "This action cannot be undone. Are you sure you want to update this add-on '" + addonName + "'?"),
      centered: true,
      onOk: () => {
        mutate({
          resource: "addons",
          id: id,
          values: {
            action: "update",
            addonId : addonId,
            data: {
              "version": addon.version,
              "config": addon.config
            }
          }
        });
      },
      onCancel: () => {
        console.log("Cancel update");
      },
    });
  };

  return isLoading ? ( 
    <Spin size="large"/>
  ) : (
    <div>
      <ConfigureAddon addon={addon} updateAddon={updateAddon} panelOpen={true}/>
      <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '8px', marginTop: '16px' }}>
        <Button type="primary" onClick={() => {
          onBack && onBack("");
        }}>
          Cancel
        </Button>
        <Button type="primary" onClick={handleSave} disabled={!dirty}>
          Save
        </Button>
      </div>
    </div>
  );
}